import { ViewTableValueConverter } from './types';

export enum ViewTableBackground {
  LIGHT = 'light',
  DARK = 'dark',
}

export enum ViewTableValueColor {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
}

export const ViewTableBackgroundColors: Record<ViewTableBackground, string> = {
  [ViewTableBackground.LIGHT]: '#FFFFFF',
  [ViewTableBackground.DARK]: '#1B1C17',
} as const;

export const ViewTableValueColors: Record<ViewTableValueColor, string> = {
  [ViewTableValueColor.PRIMARY]: '#1B1C17',
  [ViewTableValueColor.SECONDARY]: '#6C6C6C',
} as const;

export enum ViewTableValueConverterType {
  DEFAULT = 'default',
  PERCENTAGE = 'percentage',
}

const defaultViewTableValueConverter: ViewTableValueConverter = (
  value: string | number | null,
): string => value?.toString() ?? '';

const percentageViewTableValueConverter: ViewTableValueConverter = (
  value: string | number | null,
): string => {
  if (value === null || value === undefined) return '';

  let tmp: number;

  if (typeof value === 'number') {
    tmp = value * 100;
  } else {
    tmp = parseFloat(String(value).replace(/%/g, '').trim());
    if (isNaN(tmp)) return '';
    tmp = tmp * 100;
  }

  if (tmp === undefined) return '';

  return `${tmp.toFixed(2)}%`;
};

export const ViewTableValueConverters: Record<
  ViewTableValueConverterType,
  ViewTableValueConverter
> = {
  [ViewTableValueConverterType.DEFAULT]: defaultViewTableValueConverter,
  [ViewTableValueConverterType.PERCENTAGE]: percentageViewTableValueConverter,
} as const;
